import * as service from './service';

export const agentsStore = {
  service,
};
